export const config = {
	api: import.meta.env.VITE_API_URL,
	payApi: import.meta.env.VITE_PAYMENT_API_URL,
	payPlatform: import.meta.env.VITE_PAYMENT_APP_URL,
	url: import.meta.env.VITE_WEB_APP_URL,
	returnUrl: import.meta.env.VITE_RETURN_URL,
};
